/**
 * DocumentsPage — Technical documents library
 * TODO: Implement
 */
import Breadcrumbs from '@components/layout/Breadcrumbs';

export default function DocumentsPage() {
  return (
    <div className="sandvik-container py-6">
      <Breadcrumbs />
      <h1 className="font-sandvik-headline font-normal text-2xl text-carbon-black mb-4">Technical documents</h1>
      <p className="text-n5 font-sandvik-text">This page is under construction.</p>
    </div>
  );
}
